import React,{useState} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
    gold(num:number):void,
}

let selectedIndex = -1;

const EventBed = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        found: false,
        selected: false,
        finished: false,
        isLoading: false,
    })
    const close = ()=>{
        props.close(states.newPlay);
    }
    const see = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = -1;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                if( res.found ){
                    props.gold(res.play.gold-props.play.gold);
                }
                setStates({...states,newPlay:res.play,found:res.found,isLoading:false,selected:true});
            }
        })
    }

    if( states.selected ){
        return (
            <div id="event_bottles">
                {props.play.lover_end==="9" &&
                    <div className={classes.room}>
                        彼女はすでに冷たくなっていた<br/>
                        会いたかった相手がこの少女なのかきみにはわからない<br/>
                        思い出されることのない記憶は時間と共に欠けていく<br/>
                    </div>
                }
                {props.play.lover_end==="1" &&
                    <div className={classes.room}>
                        きみが名前を呼んでも{Tools.lover(props.play,props.param)}が目覚めることはなかった<br/>
                        彼女の旅はもう終わっている<br/>
                        きみの心には大きな穴が開いた<br/>
                    </div>
                }
                {props.play.lover_end==="2" &&
                    <div className={classes.room}>
                        きみは{Tools.lover(props.play,props.param)}の隣に腰を下ろした<br/>
                        そして一緒に暮らした日々と同じ時間を過ごした<br/>
                        旅の終わりはもうすぐそこまで来ている<br/>
                    </div>
                }
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close} style={{width:"100%"}}>立ち上がる</Button>
                    </FormControl>
                </div>
            </div>
        );
    }

    return (
        <div id="event_bed">
            <div className={classes.room}>
                ベッドの上に{Tools.lover(props.play,props.param)}を見つけた<br/>
            </div>
            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <Button variant="outlined" color="primary" onClick={see} style={{marginBottom:"0.2em"}}>近くへ</Button>
                </FormControl>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventBed;
